import { a163, a748 } from "Components/Api/RootApiPath";

export const fetchSKUList = async ({ queryKey }) => {
  const [, clientCode] = queryKey;
  try {
    const data = await fetch(a163, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ClientCode: clientCode,
      }),
    });
    if (!data.ok) {
      throw new Error(
        `${response.statusText || "Failed to fetch sku list"}`
      );
    }
    const res = await data?.json();
    return res;
  } catch (e) {
    console.log(e.message);
    throw new Error(`${"Failed to fetch sku list, try again later"}`);
  }
};

export const fetchSKUDetail = async ({ queryKey }) => {
    const [, id,clientCode] = queryKey;
    try {
      const data = await fetch(a748, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ClientCode: clientCode,
          Id:id
        }),
      });
      if (!data.ok) {
        throw new Error(
          `${response.statusText || "Failed to fetch sku detail"}`
        );
      }
      const res = await data?.json();
      return res;
    } catch (e) {
      console.log(e.message);
      throw new Error(`${"Failed to fetch sku detail, try again later"}`);
    }
  };